async function defineClass() {
  const promise = customElements.whenDefined("search-form");
  await promise;

  class PredictiveSearch extends SearchForm {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('input[type="search"]');
      this.searchAnimatedForm = this.querySelectorAll('form.search');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.searchInput = this.querySelector('.search__input');
      this.openSearchButtons = this.querySelectorAll('.header__icon--search');
      this.searchToggleDropdown = document.querySelector('.header-search-below');
      this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
      this.isOpen = false;
      this.abortController = new AbortController();
      this.searchTerm = '';
      this.setupEventListeners();
      this.animatedInput();
    }
  
    setupEventListeners() {
      if (this.input && this.input.form) {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
      }
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));

      window.addEventListener('resize', () => {
        this.close(false);

        const searchBelow = this.searchToggleDropdown || document.querySelector('.header-search-below');
        if (searchBelow) {
          searchBelow.classList.remove('active');
          searchBelow.removeAttribute('open');

          const isMobile = window.matchMedia('(max-width: 767px)').matches;
          const isDefaultMobile = searchBelow.classList.contains('default-mobile');

          if (!(isMobile && isDefaultMobile)) {
            searchBelow.inert = true;
          } else {
            searchBelow.inert = false;
          }
        }

        const searchButtons = document.querySelectorAll('.header__icon--search');
        searchButtons.forEach((button) => {
          button.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');

          const detailsParent = button.closest('details');
          if (detailsParent) {
            detailsParent.removeAttribute('open');
          }
        });

        const searchModal = this.closest('details, .search-modal, [data-search-modal]');
        if (searchModal) {
          searchModal.removeAttribute('open');
          searchModal.classList.remove('active');
        }
      });

      const searchButtons = document.querySelectorAll('.header__icon--search');
      searchButtons.forEach((button) => {
        button.addEventListener("click", this.onButtonClick.bind(this));
      });

      const isInHeader = !!this.closest('.header, .section-header, .header-search-below');

      if (isInHeader) {
      if (this.input && this.input.form) {
        this.input.form.addEventListener('submit', () => {
          sessionStorage.setItem('clearHeaderSearchNextPage', 'true');
        });
      }

      const handlePageReset = () => {
        const shouldClear = sessionStorage.getItem('clearHeaderSearchNextPage');
        if (shouldClear || window.location.pathname.includes('/search')) {
          this.close(true);

          const searchBelow = this.searchToggleDropdown || document.querySelector('.header-search-below');
          if (searchBelow) {
            searchBelow.classList.remove('active');
            searchBelow.removeAttribute('open');
            
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const isDefaultMobile = searchBelow.classList.contains('default-mobile');
            if (!(isMobile && isDefaultMobile)) {
              searchBelow.inert = true;
            }
          }

          const searchButtons = document.querySelectorAll('.header__icon--search');
          searchButtons.forEach((button) => {
            button.classList.remove('active');
            button.setAttribute('aria-expanded', 'false');
          });

          sessionStorage.removeItem('clearHeaderSearchNextPage');
        }
        };

        window.addEventListener('pageshow', handlePageReset);
        document.addEventListener('DOMContentLoaded', handlePageReset);
      }
    }

    handleBodyScrollClass() {
      const isOpen = this.getAttribute('open') === 'true';
      document.body.classList.toggle('overflow-hidden-tablet', isOpen);
    }

    onButtonClick(event) {
      if (event) event.preventDefault();

      const searchOrigin = this.dataset.origin;
      const isDesktop = window.matchMedia("(min-width: 768px)").matches;

      let headerInput = 
        this.querySelector('.header .search__input, .header input[type="search"]') || 
        document.querySelector('.section-header .search__input, .section-header input[type="search"], header .search__input') ||
        this.querySelector('.search__input');

      if (headerInput) {
        setTimeout(() => {
          headerInput.focus({ preventScroll: true });
        }, 20);
      }
    }

    animatedInput() {
      this.searchAnimatedForm.forEach(function(event) {
        const searchAnimatedContainer = event.querySelector('label.field__label span.animated-label-text');
        const searchAnimatedStyle = event.dataset.animated_style;
        const searchAnimatedText = event.dataset.animated_text;
        if (!searchAnimatedText) return;

        const searchAnimatedArray = searchAnimatedText.split('\n');
        const searchModifiedArray = searchAnimatedArray.map(item => item);
        
        if (searchModifiedArray.length > 1 && searchAnimatedStyle !== 'none'){
          let searchAnimatedIndex = 0;
          let searchAnimatedCharIndex = 0;
          let searchAnimatedDelete = false;
          
          if (searchAnimatedStyle === 'fade') {
            function showNextWord() {
              if (searchAnimatedIndex < searchModifiedArray.length) {
                if (searchAnimatedContainer) {
                  searchAnimatedContainer.textContent = searchModifiedArray[searchAnimatedIndex];
                  searchAnimatedContainer.style.transition = "opacity 0.5s ease-in-out";
                  searchAnimatedContainer.style.opacity = '1';
                }
                setTimeout(() => {
                    if (searchAnimatedContainer) searchAnimatedContainer.style.opacity = '0';
                    searchAnimatedIndex++;
                    setTimeout(showNextWord, 1000);
                }, 2000);
              } else {
                searchAnimatedIndex = 0;
                setTimeout(showNextWord, 300);
              }
            } 
            showNextWord();
          } else {
            function searchTypedWord() {
              const searchCurrentWord = searchModifiedArray[searchAnimatedIndex % searchModifiedArray.length];
              if (searchAnimatedContainer) {
                if (searchAnimatedDelete) {
                  searchAnimatedContainer.textContent = searchCurrentWord.substring(0, searchAnimatedCharIndex - 1);
                  searchAnimatedCharIndex--;
                } else {
                  searchAnimatedContainer.textContent = searchCurrentWord.substring(0, searchAnimatedCharIndex + 1);
                  searchAnimatedCharIndex++;
                }
              }
              let searchTypeSpeed = 300;
              if (searchAnimatedDelete) {
                searchTypeSpeed /= 4;
              }
              if (!searchAnimatedDelete && searchAnimatedCharIndex === searchCurrentWord.length) {
                searchTypeSpeed = 500;
                searchAnimatedDelete = true;
              } else if (searchAnimatedDelete && searchAnimatedCharIndex === 0){
                searchAnimatedDelete = false;
                searchAnimatedIndex++;
                searchTypeSpeed = 500;
              }
              setTimeout(searchTypedWord, searchTypeSpeed);
            } 
            searchTypedWord();
          }
        } else {
          if (searchAnimatedContainer) {
            searchAnimatedContainer.classList.remove('typed');
            searchAnimatedContainer.innerHTML = searchAnimatedArray[0];
          }
        }
      });
    }
  
    getQuery() {
      return this.input ? this.input.value.trim() : '';
    }
  
    onChange() {
      super.onChange();
      const newSearchTerm = this.getQuery();

      if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
        this.querySelector('[data-predictive-search-wrapper]')?.remove() 
          || this.querySelector('.predictive-search__results-wrapper')?.remove();
      }

      this.updateSearchForTerm(this.searchTerm, newSearchTerm);
      this.searchTerm = newSearchTerm;

      if (!this.searchTerm.length) {
        this.close(true);
        return;
      }

      this.getSearchResults(this.searchTerm);
    }
  
    onFormSubmit(event) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
  
    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) {
        this.searchTerm = '';
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();
        this.closeResults(true);
      }
    }
  
    onFocus() {
      const currentSearchTerm = this.getQuery();
  
      if (!currentSearchTerm.length) return;
  
      if (this.searchTerm !== currentSearchTerm) {
        this.onChange();
      } else if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(this.searchTerm);
      }
    }
  
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }
  
    onKeyup(event) {
      if (!this.getQuery().length) this.close(true);
      event.preventDefault();
  
      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up');
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    }
  
    onKeydown(event) {
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        event.preventDefault();
      }
    }
  
    updateSearchForTerm(previousTerm, newTerm) {
      const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
      if (!searchForTextElement) return;

      const currentButtonText = searchForTextElement.innerText;
      if (!currentButtonText || !previousTerm) return;

      try {
        const sanitizedPreviousTerm = previousTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const matches = currentButtonText.match(new RegExp(sanitizedPreviousTerm, 'g'));

        if (matches && matches.length > 1) {
          return;
        }

        const newButtonText = currentButtonText.replace(previousTerm, newTerm);
        searchForTextElement.innerText = newButtonText;
      } catch (error) {
        console.warn('[Predictive Search] Term update skipped:', error);
      }
    }
  
    switchOption(direction) {
      if (!this.getAttribute('open')) return;
  
      const moveUp = direction === 'up';
      const selectedElement = this.querySelector('[aria-selected="true"]');
  
      const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
        (element) => element.offsetParent !== null
      );
      let activeElementIndex = 0;
  
      if (moveUp && !selectedElement) return;
  
      let selectedElementIndex = -1;
      let i = 0;
  
      while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
        if (allVisibleElements[i] === selectedElement) {
          selectedElementIndex = i;
        }
        i++;
      }
  
      if (this.statusElement) this.statusElement.textContent = '';
  
      if (!moveUp && selectedElement) {
        activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
      } else if (moveUp) {
        activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
      }
  
      if (activeElementIndex === selectedElementIndex) return;
  
      const activeElement = allVisibleElements[activeElementIndex];

      if (activeElement) {
        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);
        if (this.input) this.input.setAttribute('aria-activedescendant', activeElement.id);
      }
    }
  
    selectOption() {
      const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      if (selectedOption) selectedOption.click();
    }
  
    getSearchResults(searchTerm) {
      const queryKey = searchTerm.trim().replace(/\s+/g, '-').toLowerCase();
      this.setLiveRegionLoadingState();

      if (this.cachedResults && this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      const searchUrl = `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`;

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      fetch(searchUrl, {
        signal: this.abortController.signal,
      })
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const parsedDOM = new DOMParser().parseFromString(text, 'text/html');
          
          const section = parsedDOM.querySelector('#shopify-section-predictive-search') 
                      || parsedDOM.querySelector('[data-predictive-search-results]')
                      || parsedDOM.body;

          if (!section) {
            this.close();
            return;
          }

          const resultsMarkup = section.innerHTML;

          if (this.allPredictiveSearchInstances) {
            this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
              if (predictiveSearchInstance && predictiveSearchInstance.cachedResults) {
                predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
              }
            });
          }

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.name === 'AbortError' || error?.code === 20) {
            return;
          }
          this.close();
        });
    }
  
    setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
      this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
  
      if (this.loadingText) this.setLiveRegionText(this.loadingText);
      this.setAttribute('loading', true);
    }
  
    setLiveRegionText(statusText) {
      if (!this.statusElement) return;
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;
  
      setTimeout(() => {
        if (this.statusElement) this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }
  
    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults = this.predictiveSearchResults || this.querySelector('[data-predictive-search]');
      
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
      }
      
      this.setAttribute('results', true);
      this.setLiveRegionResults();
      this.open();
    }

    open() {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
      }
      this.setAttribute('open', true);
      if (this.input) this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;

      const searchBelow = this.searchToggleDropdown || document.querySelector('.header-search-below');
      if (searchBelow) searchBelow.inert = false;
      
      this.handleBodyScrollClass();
    }
  
    setLiveRegionResults() {
      this.removeAttribute('loading');
      const countElement = this.querySelector('[data-predictive-search-live-region-count-value]');
      if (countElement) {
        this.setLiveRegionText(countElement.textContent);
      }
    }
  
    getResultsMaxHeight() {
      const headerElement = document.querySelector('.section-header') || document.querySelector('#shopify-section-header');
      const headerBottom = headerElement ? headerElement.getBoundingClientRect().bottom : 0;
      
      const availableHeight = window.innerHeight - headerBottom;
      this.resultsMaxHeight = availableHeight > 100 ? availableHeight : window.innerHeight * 0.8;
      
      return this.resultsMaxHeight;
    }
  
    close(clearSearchTerm = false) {
      this.closeResults(clearSearchTerm);
      this.isOpen = false;
    }
  
    closeResults(clearSearchTerm = false) {
      if (clearSearchTerm) {
        if (this.input) this.input.value = '';
        this.searchTerm = '';
        this.removeAttribute('results');

        const resetButton = this.querySelector('.reset__button, [type="reset"]');
        if (resetButton) {
          resetButton.classList.add('hidden');
          resetButton.setAttribute('hidden', '');
        }
      }

      const selected = this.querySelector('[aria-selected="true"]');

      if (selected) selected.setAttribute('aria-selected', false);

      if (this.input) {
        this.input.setAttribute('aria-activedescendant', '');
        this.input.setAttribute('aria-expanded', false);
      }
      
      this.removeAttribute('loading');
      this.removeAttribute('open');
      this.resultsMaxHeight = false;

      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.innerHTML = '';
        this.predictiveSearchResults.removeAttribute('style');
      }

      this.handleBodyScrollClass();
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
}

defineClass();